import templateUrl from './list-icd-offices.component.html';

export const ListIcdOfficesComponent = {
    controller: ListIcdOfficesComponentController,
    controllerAs: "vm",
    templateUrl,
    bindings: {
        icdOffices: "<",
        icdCorporationID: "<?icdCorporationId",
        changeFilters: "&",
        delete: "&",
        filters: "<"
    }
};

function ListIcdOfficesComponentController() {
    const vm = this;

    vm.changeFilters;
    vm.delete;
    vm.icdOffices;
    vm.icdCorporationID;
    vm.filters;
    vm.onChangeFilters = onChangeFilters;
    vm.onDelete = onDelete;

    function onChangeFilters() {
        vm.changeFilters({ filters: vm.filters });
    }

    function onDelete(icdoffice) {
        vm.delete({ icdoffice: icdoffice });
    }
}
